import React, {Component} from "react";
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {withAuthorization} from "../../../services/Authorization";

class OutsideBusinessHour extends Component {

  on247Select = () => {
    const {selectable, selected, onSelect} = this.props;
    if (!selected && onSelect && selectable) {
      onSelect();
    }
  };

  render() {
    const {intl: {formatMessage}, type, selected} = this.props;
    const selectedCss = selected === true ? undefined : "choice-card--unselected";

    if (!type) {
      return null;
    }

    return (
      <div>
        <div className={["choice-card", selectedCss].join(' ')} onClick={this.on247Select}>
          <header className="choice-card__header">
            <h4 className="choice-card__title">{formatMessage({id: '24/7'})}</h4>
          </header>
          <div className="choice-card__body">
           
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuthorization(injectIntl(OutsideBusinessHour), ['DUI_ADMIN', 'DUI_SERVICE_ADVISOR']));
